// ─────────────────────────────────────────────
// Scroll lên đầu trang
// ─────────────────────────────────────────────
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

// ─────────────────────────────────────────────
// Inject block quảng cáo tài khoản PRO vào trang
// Được gọi sau khi submit form đăng ký thành công
// ─────────────────────────────────────────────
function handleProRegistrationBlock() {
  const isLoginPage = window.location.pathname.includes("/account/login");
  const registerBtnLabel = isLoginPage ? "JE M'INSCRIS" : "Je m'inscris";

  const proBlockHTML = `
    <div>
      <h2 style="font-size: 27px;">
        <b>Professionnels du secteur animalier. : gagnez en rentabilité avec Cernunos®</b>
      </h2>
      <p>Vous êtes revendeur, éducateur canin, toiletteur ou tout autre professionnel du secteur animalier ?
        Accédez à des avantages exclusifs sur une large gamme de friandises pour chien et de jouets naturels,
        conçus pour répondre aux besoins des animaux et aux attentes de vos clients.</p>
      <p>En ouvrant un compte PRO chez <b>Cernunos®</b>, vous accédez à de nombreux avantages pensés
        pour optimiser votre activité et booster vos ventes.</p>

      <h3 style="padding-top: 10px; font-size: 22px;"><b>Pourquoi choisir Cernunos® ?</b></h3>

      <div>🛍️ <b>Une offre complète et disponible immédiatement</b></div>
      <ul style="padding-left: 10px;">
        <li>Accédez à <b>des centaines de références en friandises et jouets naturels</b>, toujours disponibles en stock.<br/>
          Sélectionnés pour leur qualité et leur attrait auprès de nos amis à 4 pattes, nos produits vous permettent
          de répondre efficacement à la demande, que vous vendiez en magasin, en ligne ou en direct à vos clients.</li>
      </ul>

      <div>💰 <b>Des prix compétitifs et des marges optimisées</b></div>
      <ul style="padding-left: 10px;">
        <li><b>Un minimum de commande accessible : seulement 100€HT (120€TTC)</b></li>
        <li>Nos tarifs sont conçus pour vous offrir une rentabilité optimale, même avec de petites quantités.
          Vous pouvez ainsi tester nos produits sans engagement important.</li>
        <li><b>Plus vous commandez, plus vous gagnez !</b></li>
        <li>En augmentant vos quantités, vous améliorez vos marges tout en réduisant les risques de ruptures de stock.
          Profitez d'une stratégie d'achat intelligente pour optimiser vos bénéfices.</li>
      </ul>

      <div>🚚 <b>Livraison express et frais de port réduits</b></div>
      <ul style="padding-left: 10px;">
        <li>Nous assurons des expéditions rapides sous <b>24/48h</b> avec des options de livraison avantageuses :
          <ul style="margin-left: 0;">
            <li>Jusqu'à <b>50% d'économies</b> sur les frais de port par rapport aux tarifs standards</li>
            <li><b>Livraison offerte</b> dès <b>1500 € HT</b> d'achats</li>
            <li>Un service de <b>livraison express avec GLS</b> pour recevoir vos commandes au plus vite.
              (92% de nos colis arrivent en 24H)</li>
          </ul>
        </li>
      </ul>

      <div>📞 <b>Un service client réactif, soutenu par notre expertise e-commerce</b></div>
      <ul style="padding-left: 10px;">
        <li>Que vous soyez revendeur, gérant de boutique ou acteur du e-commerce, notre équipe vous accompagne
          avec des conseils adaptés à vos besoins. Grâce à notre expérience dans la vente en ligne,
          nous vous aidons à identifier les produits les plus porteurs, optimiser votre offre et booster vos ventes,
          en boutique comme sur internet.</li>
      </ul>

      <br />

      <h3 style="font-size: 22px;"><b>Comment ouvrir un compte PRO ?</b></h3>
      <ul style="padding-left: 10px; list-style: none;">
        <li>✅ <b>Remplissez notre formulaire en ligne</b> en 1 minute</li>
        <li>✅ <b>Un conseiller vous contacte rapidement</b> pour valider votre inscription si besoin</li>
        <li>✅ <b>Accédez immédiatement</b> à vos conditions exclusives et passez votre première commande</li>
      </ul>

      <br/>

      <p><b>👉 Rejoignez-nous dès maintenant et boostez votre activité !</b></p>

      <div class="btn-link" style="padding-top: 30px; padding-bottom: 30px;">
        <a class="btn btn-primary global-button global-button--primary" href="#" onclick="scrollToTop()">
          <i class="czi-user mr-2 ml-n1"></i>${registerBtnLabel}
        </a>
      </div>
    </div>
  `;

  document.querySelector(".one-whole").insertAdjacentHTML("beforeend", proBlockHTML);
}

// ─────────────────────────────────────────────
// Fix checkout button bị disable trên trang Quick Order (Customer Portal)
// Poll mỗi 100ms đến khi button xuất hiện, timeout sau 10s
// ─────────────────────────────────────────────
(function initQuickOrderCheckoutFix() {
  // Fallback: luôn enable #checkout sau 6s phòng trường hợp event không fire
  setTimeout(() => {
    $("#checkout").css({ pointerEvents: "auto", opacity: "1" });
  }, 6000);

  const isQuickOrderPage = window.location.pathname === "/apps/customer-portal/quick-order";
  if (!isQuickOrderPage) return;

  const pollInterval = setInterval(() => {
    const quickOrderCheckoutBtn = document.querySelector("#bss-bcp-qo-checkout-btn");
    if (!quickOrderCheckoutBtn) return;

    // Bỏ trạng thái disabled của Polaris Button
    quickOrderCheckoutBtn.setAttribute("aria-disabled", "false");
    quickOrderCheckoutBtn.classList.remove("Polaris-Button--disabled");

    // Redirect về /cart thay vì xử lý checkout mặc định
    quickOrderCheckoutBtn.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = "/cart";
    }, true);

    clearInterval(pollInterval);
  }, 100);

  // Dừng poll sau 10s nếu button không xuất hiện
  setTimeout(() => {
    clearInterval(pollInterval);
  }, 10000);
})();

// ─────────────────────────────────────────────
// Inject CSS fix layout VAT price trên Customer Portal
// ─────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const isCustomerPortalPage = window.location.pathname.includes("apps/customer-portal");
  if (!isCustomerPortalPage) return;

  const styleEl = document.createElement("style");
  styleEl.innerHTML = `
    .bss-b2b-qo-vat-price-no-vat,
    .bss-bcp-qo-vat-price-has-vat,
    .bss-bcp-qo-product-list-table .price-field > p {
      display: flex;
    }
    .bss-bcp-qo-product-list-table .price-field > p {
      gap: 4px;
    }
    .bss-bcp-qo-cart-table .line-item-total-price > p {
      display: flex;
      flex-direction: column;
    }
  `;
  document.head.appendChild(styleEl);
});

// ─────────────────────────────────────────────
// Trigger load B2B pricing rule trên product page sau 2s
// ─────────────────────────────────────────────
setTimeout(() => {
  const isProductPage = window.location.pathname.includes("/product");
  if (isProductPage && BSS_B2B) {
    BSS_B2B.ef.getAppliedRuleOnProductPage(false);
  }
}, 2000);

// ─────────────────────────────────────────────
// Trigger scroll event để kích hoạt lazy load form đăng ký PRO
// Poll đến khi form xuất hiện, timeout sau 4s
// ─────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", function () {
  const registrationPagePaths = [
    "/pages/registration-form",
    "/pages/inscription-compte-pro-cernunos",
  ];
  const isRegistrationPage = registrationPagePaths.includes(window.location.pathname);
  if (!isRegistrationPage) return;

  const pollForRegistrationForm = setInterval(() => {
    const registrationForm = document.querySelector("#bss-b2b-registration-form");
    if (!registrationForm) return;

    window.dispatchEvent(new Event("scroll"));
    clearInterval(pollForRegistrationForm);
  });

  setTimeout(() => {
    clearInterval(pollForRegistrationForm);
  }, 4000);
});

// ─────────────────────────────────────────────
// Sau khi form đăng ký submit thành công → inject block PRO
// ─────────────────────────────────────────────
document.addEventListener("BSS_get_form_success", () => {
  const registrationPagePaths = [
    "/pages/registration-form",
    "/pages/inscription-compte-pro-cernunos",
  ];
  const isRegistrationPage = registrationPagePaths.includes(window.location.pathname);
  console.log({isRegistrationPage})
  if (isRegistrationPage) {
    handleProRegistrationBlock();
  }
});